import { render, staticRenderFns } from "./ConsolidadoIndemnizaciones.vue?vue&type=template&id=afa59de8&"
import script from "./ConsolidadoIndemnizaciones.vue?vue&type=script&lang=js&"
export * from "./ConsolidadoIndemnizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports